import {FormEvent, FunctionComponent} from "react";
import {Box, BoxProps} from "@mui/material";

interface IFormProps extends BoxProps {
    onCommit?: () => void
}
export const Form: FunctionComponent<IFormProps> = (props: IFormProps) => {
    const handleSubmit = (event: FormEvent) => {
        props.onCommit && props.onCommit();
        event.preventDefault();
    }
    const boxProps = {...props};

    delete boxProps.onCommit
    return <Box component="form" onSubmit={handleSubmit} {...boxProps}/>
}